import { formatSum } from './requestsColDefs'
import type { RequestsSummary } from '../../../shared/api/requests.api'
import type { GridStats } from '../hooks/useGridFilterStats'

/**
 * Лейблы-счётчики для шапки списка заявок и блока «Обработанные». Вынесены из
 * RequestsPage, чтобы не раздувать страницу (правило ≤500 строк). Логика та же:
 * при активных фильтрах считаем по видимым строкам грида, иначе — точный
 * серверный итог из summary.
 */

/** Счётчик активных заявок + сумма КП в шапке страницы. */
export function ActiveSummaryLabel({
  filtersOn,
  stats,
  summary,
}: {
  filtersOn: boolean
  stats: GridStats
  summary: RequestsSummary | undefined
}) {
  const count = filtersOn ? stats.count : (summary?.active.count ?? stats.count)
  const kpSum = filtersOn ? stats.kpSum : (summary?.active.kpSum ?? stats.kpSum)
  return (
    <span className="text-sm text-gray-500">
      {filtersOn ? 'найдено: ' : 'активных: '}
      <span className="font-medium text-gray-900">{count}</span>
      {' · '}сумма КП: <span className="font-medium text-gray-900">{formatSum(kpSum)}</span>
    </span>
  )
}

/** Счётчик обработанных заявок + суммы КП/в заказ в шапке свёрнутого блока. */
export function ProcessedSummaryLabel({
  showProcessed,
  filtersOn,
  stats,
  fallbackCount,
  summary,
  isSalesView,
}: {
  showProcessed: boolean
  filtersOn: boolean
  stats: GridStats
  fallbackCount: number
  summary: RequestsSummary | undefined
  isSalesView: boolean
}) {
  const count = filtersOn ? stats.count : (summary?.processed.count ?? fallbackCount)
  const kpSum = filtersOn ? stats.kpSum : (summary?.processed.kpSum ?? 0)
  const orderedSum = filtersOn ? stats.orderedSum : (summary?.processed.orderedSum ?? 0)
  const showSums = isSalesView && (filtersOn || !!summary)
  return (
    <span>
      {showProcessed ? '▼' : '▶'} Обработанные заявки ({count})
      {showSums && (
        <span className="ml-2 font-normal text-gray-500">
          · сумма КП: {formatSum(kpSum)} · в заказ:{' '}
          <span className="text-gray-700">{formatSum(orderedSum)}</span>
          {kpSum > 0 && (
            <span className="ml-1 text-gray-400">({Math.round((orderedSum / kpSum) * 100)}%)</span>
          )}
        </span>
      )}
    </span>
  )
}
